'use strict';

exports.__esModule = true;
exports.ProjectTasksListView = exports.styles = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('react-sortable-tree/style.css');

var _reactSortableTree = require('react-sortable-tree');

var _reactSortableTree2 = _interopRequireDefault(_reactSortableTree);

var _List = require('../../../../Tasks/View/List');

var _List2 = _interopRequireDefault(_List);

var _materialUi = require('material-ui');

var _AddCircleOutline = require('material-ui-icons/AddCircleOutline');

var _AddCircleOutline2 = _interopRequireDefault(_AddCircleOutline);

var _Task = require('./Task');

var _Task2 = _interopRequireDefault(_Task);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = function styles(theme) {
  var baseStyles = (0, _Task.styles)(theme); // console.log("baseStyles", baseStyles);

  var status = baseStyles.status;
  var row = {};

  for (var i in status) {
    row[i + '.status'] = {
      "& .rst__moveHandle": _extends({}, status[i])
    };
  }

  return _extends({}, baseStyles, {
    root: {
      height: 700
    },
    row: row
  });
};

var ProjectTasksListView = exports.ProjectTasksListView = (_temp = _class = function (_TasksListView) {
  _inherits(ProjectTasksListView, _TasksListView);

  function ProjectTasksListView(props) {
    var _this2 = this;

    _classCallCheck(this, ProjectTasksListView);

    var _this = _possibleConstructorReturn(this, _TasksListView.call(this, props));

    _this.onMoveNode = function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regenerator2.default.mark(function _callee(data) {
        var treeData, node, nextParentNode, prevPath, prevTreeIndex, nextPath, nextTreeIndex, updateTaskProcessor, id, Parent, _id, result;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                treeData = data.treeData, node = data.node, nextParentNode = data.nextParentNode, prevPath = data.prevPath, prevTreeIndex = data.prevTreeIndex, nextPath = data.nextPath, nextTreeIndex = data.nextTreeIndex; // const {
                //   updateTaskProcessorQuery,
                // } = this.props;

                updateTaskProcessor = _this.context.query.updateTaskProcessor;
                id = node.id;
                Parent = void 0;

                if (nextParentNode) {
                  _id = nextParentNode.id;
                  Parent = {
                    connect: {
                      id: _id
                    }
                  };
                } else if (prevPath && prevPath.length > 1) {
                  Parent = {
                    disconnect: true
                  };
                }

                _context.next = 7;
                return _this.mutate({
                  mutation: (0, _graphqlTag2.default)(updateTaskProcessor),
                  variables: {
                    where: {
                      id: id
                    },
                    data: {
                      Parent: Parent
                    }
                  }
                });

              case 7:
                result = _context.sent;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = _extends({}, _this.state, {
      treeData: [],
      newChilds: [],
      expanded: [],
      expandedAll: true
    });
    return _this;
  }

  ProjectTasksListView.prototype.getNodeKey = function getNodeKey(_ref2) {
    var node = _ref2.node,
        treeIndex = _ref2.treeIndex;
    var id = node.id;
    return id || treeIndex;
  };

  ProjectTasksListView.prototype.renderItems = function renderItems() {
    var _this3 = this;

    var _props = this.props,
        classes = _props.classes,
        tasks = _props.tasks,
        project = _props.project;
    var _state = this.state,
        newChilds = _state.newChilds,
        expanded = _state.expanded,
        expandedAll = _state.expandedAll;
    var treeData = [];

    if (!tasks || !project) {
      return null;
    }

    var ProjectLink = this.context.ProjectLink;
    var projectId = project.id;
    var nodes = tasks.map(function (n) {
      var id = n.id;
      return _extends({}, n, {
        expanded: expandedAll || id && expanded.indexOf(id) !== -1 ? true : false,
        children: []
      });
    }).concat(newChilds);
    /**
     * Сначала получаем первый уровень
     */
    // let rootLevel = tasks.filter(n => !n.Parent).map(n => ({
    //   ...n,
    //   children: [],
    // }));

    /**
     * Обрабатываем все остальные ноды, создавая иерархию
     */

    /**
     * Сортировка происходит в два этапа:
     * 1. Создаем одноуровневый массив всех элементов.
     * 2. Затем делаем его клон (сохраняя сами элементы).
     * 3. Последним этапом проходим по каждому элементу и если находим элемент, закидываем его дочерним в него
     */

    var nodesTree = [];
    nodes.map(function (n) {
      var Parent = n.Parent;

      if (Parent) {
        var parentNode = nodes.find(function (n) {
          return n.id === Parent.id;
        });

        if (parentNode) {
          parentNode.children.push(n);
          return;
        }
      }
      /**
       * Если не был добавлен в другую ноду, выводим в корень
       */


      nodesTree.push(n);
    });
    nodesTree.map(function (n) {
      treeData.push(n);
    });
    return _react2.default.createElement('div', {
      className: classes.root
    }, _react2.default.createElement(_reactSortableTree2.default, {
      rowHeight: 74,
      treeData: treeData,
      getNodeKey: this.getNodeKey,
      onChange: function onChange(treeData) {// console.log("onChange treeData", treeData);
        // this.setState({ treeData });
      },
      onVisibilityToggle: function onVisibilityToggle(_ref3) {
        var treeData = _ref3.treeData,
            node = _ref3.node,
            expanded = _ref3.expanded,
            path = _ref3.path;
        console.log("onVisibilityToggle treeData", treeData, node, expanded, path); // this.setState({ treeData });

        var id = node.id;

        if (!id) {
          return;
        }

        var _state2 = _this3.state,
            prevExpanded = _state2.expanded,
            expandedAll = _state2.expandedAll;
        var newExpanded = [].concat(prevExpanded);

        if (expandedAll) {
          expandedAll = false;
          path.splice(-1, 1);
          newExpanded = [].concat(path);
        } else if (expanded) {
          newExpanded.push(id);
        } else {
          newExpanded.splice(newExpanded.indexOf(id), 1);
        }

        _this3.setState({
          expandedAll: expandedAll,
          expanded: newExpanded
        });
      },
      onMoveNode: this.onMoveNode,
      generateNodeProps: function generateNodeProps(_ref4) {
        var node = _ref4.node,
            path = _ref4.path; // console.log("generateNodeProps", node, path);

        var taskId = node.id,
            title = node.name,
            status = node.status;
        var buttons = [];

        if (taskId) {
          buttons.push(_react2.default.createElement(_materialUi.IconButton, {
            onClick: function onClick(event) {
              // console.log("onAddClick", event);
              // return;
              // this.setState(state => ({
              //   treeData: addNodeUnderParent({
              //     treeData,
              //     parentKey: path[path.length - 1],
              //     expandParent: true,
              //     getNodeKey: this.getNodeKey,
              //     newNode: {
              //       id: "DSfsdf",
              //       title: `rgergerg`,
              //     },
              //     // addAsFirstChild: state.addAsFirstChild,
              //     addAsFirstChild: true,
              //   }).treeData,
              // }))
              var newItem = {
                Parent: {
                  id: taskId
                },
                _dirty: {
                  name: "",
                  Project: {
                    connect: {
                      id: projectId
                    }
                  },
                  Parent: {
                    connect: {
                      id: taskId
                    }
                  }
                }
              };

              newItem.onSave = function (result) {
                var success = result.data.response.success;

                if (success) {
                  var _newChilds = _this3.state.newChilds;
                  /**
                    Если успешно сохранено, то удаляем из новых элементов
                   */

                  var index = _newChilds.indexOf(newItem);

                  if (index !== -1) {
                    _newChilds.splice(index, 1);

                    _this3.setState({
                      newChilds: _newChilds
                    });
                  }
                }
              };

              _this3.setState({
                newChilds: [].concat(newChilds).concat([newItem])
              });
            }
          }, _react2.default.createElement(_AddCircleOutline2.default, null)));
        }

        return {
          className: [classes.row, "status", status].join(" "),
          // subtitle: () => <div>
          //   <ProjectLink
          //     object={project}
          //   />
          // </div>,
          title: function title() {
            return _this3.renderItem(node);
          },
          buttons: buttons
        };
      }
    }));
  };

  ProjectTasksListView.prototype.renderItem = function renderItem(task, props) {
    var _dirty = task._dirty,
        onSave = task.onSave,
        other = _objectWithoutProperties(task, ['_dirty', 'onSave']);

    return _TasksListView.prototype.renderItem.call(this, other, _extends({}, props, {
      onSave: onSave,
      _dirty: _dirty
    }));
  };

  return ProjectTasksListView;
}(_List2.default), _class.propTypes = _extends({}, _List2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired,
  project: _propTypes2.default.object.isRequired
}), _class.defaultProps = _extends({}, _List2.default.defaultProps, {
  TaskView: _Task2.default
}), _temp);
exports.default = (0, _materialUi.withStyles)(styles)(function (props) {
  return _react2.default.createElement(ProjectTasksListView, props);
});